import React, { useEffect, useState } from 'react';
import client from '../api/client';
import { useAuth } from '../context/AuthContext';

const empty = { name_ar: '', name_en: '', type: 'shooting_club', country: '', contact_name: '', contact_email: '', contact_phone: '' };

const TYPE_LABELS = {
  federation: 'اتحاد',
  national_team: 'منتخب وطني',
  shooting_club: 'نادي رماية',
  individual: 'فردي (لاعب مستقل)',
  media: 'إعلام',
  sponsor: 'راعٍ',
  government: 'جهة حكومية',
  other: 'أخرى'
};

const TYPE_COLORS = {
  federation: '#2563eb', national_team: '#7c3aed', shooting_club: '#16a34a',
  individual: '#ca8a04', media: '#0891b2', sponsor: '#dc2626', government: '#6b7280', other: '#9ca3af'
};

export default function Organizations() {
  const { user } = useAuth();
  const isAdmin = user.role === 'admin';
  const [rows, setRows] = useState([]);
  const [form, setForm] = useState(empty);
  const [editingId, setEditingId] = useState(null);
  const [filterType, setFilterType] = useState('');
  const [error, setError] = useState(null);

  const load = () => client.get('/organizations').then(r => setRows(r.data));
  useEffect(() => { load(); }, []);

  const submit = async (e) => {
    e.preventDefault();
    setError(null);
    try {
      if (editingId) await client.put(`/organizations/${editingId}`, form);
      else await client.post('/organizations', form);
      setForm(empty); setEditingId(null);
      load();
    } catch (err) {
      setError(err.response?.data?.message || 'خطأ');
    }
  };

  const edit = (o) => {
    setForm({ name_ar: o.name_ar, name_en: o.name_en || '', type: o.type, country: o.country || '', contact_name: o.contact_name || '', contact_email: o.contact_email || '', contact_phone: o.contact_phone || '' });
    setEditingId(o.id);
  };

  const remove = async (id) => {
    if (!window.confirm('تأكيد الحذف؟')) return;
    try { await client.delete(`/organizations/${id}`); load(); }
    catch (err) { alert(err.response?.data?.message || 'خطأ'); }
  };

  const filteredRows = filterType ? rows.filter(o => o.type === filterType) : rows;

  return (
    <div className="grid grid-2">
      <div className="card">
        <h3 style={{ marginTop: 0 }}>{editingId ? 'تعديل جهة / اتحاد' : 'إضافة جهة / نادي / لاعب فردي'}</h3>
        {error && <div className="alert alert-error">{error}</div>}
        <form onSubmit={submit}>
          <div className="form-field" style={{ marginBottom: 10 }}>
            <label>الاسم (عربي) *</label>
            <input value={form.name_ar} onChange={e => setForm({ ...form, name_ar: e.target.value })} required />
          </div>
          <div className="form-field" style={{ marginBottom: 10 }}>
            <label>الاسم (English)</label>
            <input value={form.name_en} onChange={e => setForm({ ...form, name_en: e.target.value })} />
          </div>
          <div className="form-field" style={{ marginBottom: 10 }}>
            <label>النوع</label>
            <select value={form.type} onChange={e => setForm({ ...form, type: e.target.value })}>
              <option value="shooting_club">نادي رماية</option>
              <option value="individual">فردي (لاعب مستقل)</option>
              <option value="federation">اتحاد</option>
              <option value="national_team">منتخب وطني</option>
              <option value="media">إعلام</option>
              <option value="sponsor">راعٍ</option>
              <option value="government">جهة حكومية</option>
              <option value="other">أخرى</option>
            </select>
          </div>
          <div className="form-field" style={{ marginBottom: 10 }}>
            <label>الدولة</label>
            <input value={form.country} onChange={e => setForm({ ...form, country: e.target.value })} />
          </div>
          <div className="form-field" style={{ marginBottom: 10 }}>
            <label>بريد التواصل</label>
            <input type="email" value={form.contact_email} onChange={e => setForm({ ...form, contact_email: e.target.value })} />
          </div>
          <div style={{ display: 'flex', gap: 8 }}>
            <button className="btn btn-primary">{editingId ? 'حفظ التعديلات' : 'إضافة'}</button>
            {editingId && <button type="button" className="btn btn-outline" onClick={() => { setEditingId(null); setForm(empty); }}>إلغاء</button>}
          </div>
        </form>
      </div>

      <div className="card">
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 10, flexWrap: 'wrap', gap: 8 }}>
          <h3 style={{ margin: 0 }}>الجهات المسجلة ({filteredRows.length})</h3>
          <select value={filterType} onChange={e => setFilterType(e.target.value)} style={{ padding: '6px 10px', borderRadius: 8, border: '1px solid var(--line)', fontSize: 13 }}>
            <option value="">كل الأنواع</option>
            {Object.entries(TYPE_LABELS).map(([k, v]) => <option key={k} value={k}>{v}</option>)}
          </select>
        </div>
        <table>
          <thead><tr><th>الاسم</th><th>النوع</th><th>الدولة</th><th></th></tr></thead>
          <tbody>
            {filteredRows.map(o => (
              <tr key={o.id}>
                <td>{o.name_ar}</td>
                <td><span className="badge" style={{ background: TYPE_COLORS[o.type] || '#9ca3af' }}>{TYPE_LABELS[o.type] || o.type}</span></td>
                <td>{o.country}</td>
                <td style={{ display: 'flex', gap: 6 }}>
                  <button className="btn btn-outline" onClick={() => edit(o)}>تعديل</button>
                  {isAdmin && <button className="btn btn-danger" onClick={() => remove(o.id)}>حذف</button>}
                </td>
              </tr>
            ))}
            {filteredRows.length === 0 && <tr><td colSpan="4" style={{ textAlign: 'center', color: '#9ca3af' }}>لا توجد نتائج</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
